export function Badge({ label, icon }) {
    return (
        <div className="inline-flex items-center justify-center text-blue text-[0.54rem] p-4 bg-yellow space-x-2 rounded">
            <span className="text-[0.5rem]">{icon}</span>
            <span>{label}</span>
        </div>
    )
}
